/* eslint-disable @typescript-eslint/prefer-literal-enum-member */
// @ts-strict-ignore
/*
Empty values have to be undefined. Null does not work, because null is recognized by google as not empty
*/

/**
 * TODO: Fix with MBCC-2657 - refactor this (and its usecases)
 * enums do not allow undefined values.
 * this needs to change for strict compliance.
 * i question the need for this enum at all. current use case is, if a tracking
 * detail is not undefined, this "placeholder" is used, that has a labelled
 * value of undefined. That makes development more complicated but doesn't
 * provide any real value as the tracking detail is already undefined will be
 * sent as undefined. This is a case of overengineering.
 * suggestion: remove enum completely and simply use undefined if data is unset.
 * ! clarify with tracking people
 *
 * @deprecated use undefined instead
 */
export enum TrackingPlaceholder {
  LabelUndefined = undefined,
  PriceUndefined = undefined,
  ItemNameUndefined = undefined,
  ActionUndefined = undefined,
  CategoryUndefined = undefined,
  ErrorTypeUndefined = undefined,
  ErrorDescriptionUndefined = undefined,
  ModelCodeUndefined = undefined,
  UniversalUndefined = undefined
}
